class VideoCarousel extends HTMLElement {
  constructor() {
    super();

    const options = JSON.parse(this.getAttribute('data-options'));

    this.videoButton = this.querySelector('.video-carousel__video-button');
    this.videos = this.querySelectorAll('video');
    this.carousel = new Flickity(this, options);
    this.selectedIndex = 0;

    if(options.navButton) {
      this.buttons = this.parentElement.querySelectorAll(options.navButton);
      this.buttons.forEach(button => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }

    this.carousel.on('change', this.onChange.bind(this));
    this.carousel.on('staticClick', this.onStaticClick.bind(this));
    this.videos.forEach(video => {
      video.addEventListener('ended', this.onVideoEnd.bind(this));
    });
  }

  onChange () {
    if(this.videoButton) this.videoButton.remove();

    this.videos.forEach((video, index) => {
      if(index != this.carousel.selectedIndex) video.pause();
    });

    this.videos[this.carousel.selectedIndex].play();
    this.selectedIndex = this.carousel.selectedIndex;
  }

  onStaticClick (event, pointer, cellElement, cellIndex) {
    if(this.videoButton) this.videoButton.remove();
    
    this.videos.forEach((video, index) => {
      if(index != cellIndex) video.pause();
    });

    const video = cellElement.querySelector('video');

    if(cellIndex != this.selectedIndex || video.paused) {
      video.play();
    } else {
      video.pause();
    }

    this.carousel.selectCell(cellIndex);
  }

  onVideoEnd () {
    this.carousel.selectCell(this.selectedIndex + 1);
  }

  onButtonClick (event) {
    const button = event.target,
          direction = button.getAttribute('aria-direction');
    
    if(direction == 'next') {
      this.carousel.next();
    } else {
      this.carousel.previous();
    }
  }
}

customElements.define('video-carousel', VideoCarousel);

class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this.thumbnails = this.querySelectorAll('.product-thumbnails__item-link');
    this.arrowButtons = this.querySelectorAll('.scroll-button');
    this.images = this.querySelectorAll('.product__media-item.animation--product-media');
    this.index = 1;
    
    this.init();
  }

  init () {
    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
    });

    this.arrowButtons.forEach(arrow => {
      arrow.addEventListener('click', this.onArrowClick.bind(this));
    });
  }

  onThumbnailClick (event) {
    const thumbnail = event.target;

    this.thumbnails.forEach(thumb => thumb.classList.remove('active'));
    thumbnail.classList.add('active');

    this.images.forEach(image => image.classList.add('hidden'));
    
    this.index = parseInt(thumbnail.getAttribute('data-index'));
    this.images[this.index - 1].classList.remove('hidden');
  }

  onArrowClick (event) {
    const arrow = event.target;

    if(arrow.dataset.direction == 'backwards') {
      if(this.index - 1 < 1) return;

      this.index = this.index - 1;
    }

    if(arrow.dataset.direction == 'forwards') {
      if(this.thumbnails.length < this.index + 1) return;

      this.index = this.index + 1;
    }
    
    this.thumbnails.forEach(thumb => thumb.classList.remove('active'));
    this.images.forEach(image => image.classList.add('hidden'));

    this.thumbnails[this.index - 1].classList.add('active');
    this.images[this.index - 1].classList.remove('hidden');
  }
}

customElements.define('product-gallery', ProductGallery);